import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';
import { scopedOrganizationId } from '../org-scope';
import { UserResponseDto, UserRequestDto, InviteUserDto } from '../models/api.models';

@Injectable({ providedIn: 'root' })
export class UserService {
  private http = inject(HttpClient);
  private auth = inject(AuthService);
  private base = `${environment.apiUrl}/User`;

  /** Users in the caller's scope — same defaulting rule as `DeviceService.getAll`. */
  getAll(organizationId: number | null = scopedOrganizationId(this.auth.claims())): Observable<UserResponseDto[]> {
    if (organizationId != null) {
      return this.http.get<UserResponseDto[]>(this.base, { params: { organizationId: String(organizationId) } });
    }
    return this.http.get<UserResponseDto[]>(this.base);
  }

  getById(id: number): Observable<UserResponseDto> {
    return this.http.get<UserResponseDto>(`${this.base}/${id}`);
  }

  invite(dto: InviteUserDto): Observable<UserResponseDto> {
    return this.http.post<UserResponseDto>(this.base, dto);
  }

  update(id: number, dto: UserRequestDto): Observable<UserResponseDto> {
    return this.http.put<UserResponseDto>(`${this.base}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
}
